module.exports = __webpack_public_path__ + "media/images/down_arrow_white-a782d070717949b8c6c1c4e0566000da.svg";